import { createContext, useContext } from 'react';
export const TranslationContext = createContext({
    getText: (label) => label,
});
export const useTranslationContext = () => useContext(TranslationContext);
